<template>
	<div id="wp" class="wp">
		<!--[name][星点互联新版企业模板-产品案例列表页][/name]-->

		<div class="nexadsbanner">
			<em></em>
			<h4>产品案例</h4>
			<div class="nexprodesc">
				<!--[diy=nexprodesc]-->
				<div id="nexprodesc" class="area"></div>
				<!--[/diy]-->
			</div>
			<div class="nex_tools">
			</div>

		</div>
		<!--下级分类-->
		<div class="nexsubnavfg">
			<div class="nexnextnavx">
				<ul>
					<li v-for="item in getMoolsNetLabList" @click="xiangq(item.id)"><a>{{item.name}}</a></li>
		<!-- 			<li><a>乳品检测虚拟(12)</a></li>
					<li><a>无机化学(31)</a></li>
					<li><a>分析化学(41)</a></li>
					<li><a>有机化学(11)</a></li>
					<li><a>物理化学(21)</a></li>
					<li><a>仪器分析(2)</a></li>
					<li><a>生物化学(4)</a></li>
					<li><a>药物分析(2)</a></li>
					<li><a>化工单元操作(11)</a></li>
					<li><a>机械大类(5)</a></li>
					<li><a>物理实验(15)</a></li>
						<li><a >综合实验(1)</a></li>
					<li><a >工厂(23)</a></li>
					<li><a >高中化学(21)</a></li>
					<li><a >实验室安全(41)</a></li> -->
					<div class="clear"></div>
				</ul>
			</div>
		</div>

		<div class="nexwp">
			<div class="nex_portbox">
				<ul>
					<li  v-for="item in getMoolsNetExpList">
						<div class="nex_LG_box">
							<div class="nex_case_pic">
								<img :src="item.pic" width="280">
								<div class="nexoverlaystyle_one">
									<div class="nexinter_box">
										<div class="nexover_content">
											<a><i></i></a>
										</div>
									</div>
								</div>
							</div>

							<div class="nex_LG_info">
								<div class="nex_LG_type">{{item.name}}</div>
								<h5><a>{{item.des}}</a></h5>

								<div class="nex_LG_item">
									<span class="nex_statistics_view">{{item.lls}}</span>
									<span class="nex_statistics_comment">{{item.pls}}</span>
									<span class="nex_statistics_date">{{item.pjsj}}</span>
									<div class="clear"></div>
								</div>

							</div>

						</div>
					</li>



					<div class="clear"></div>
				</ul>
			</div>

		</div>
		<!-- <Cebianlan></Cebianlan> -->
	</div>
</template>

<script>
	import community_one from '../../components/community/Community_one.vue'
	import community_two from '../../components/community/Community_two.vue'
	import Cebianlan from '../../views/cebianlan/cebianlan.vue'
  import axios from 'axios' // 引用axios
　
	export default {
		name: 'Community',
		components: {
			community_one,
			community_two,
			Cebianlan
		},
		created() {
			document.documentElement.scrollTop = 0
		},
		data() {
			return {
				item: 'community_one', //默认显示个人中心，study/changePass/binding/personInfo/transactionInfo/message
				message_number: 1,
        getMoolsNetLabList:[],//显示分类列表
        getMoolsNetExpList:[],//根据lab_id获取项目列表
			}
		},
		methods: {
      xiangq(id){
        console.log(id)
        var that = this
        //通过给定的ID来发送请求
        axios.get("https://www.mools.net/lims/api/laravel/public/index.php/getMoolsNetExpList/"+id)
          .then(function(response){
            that.getMoolsNetExpList = response.data.data;
            console.log(response);
          })
          .catch(function(err){
            console.log(err);
          });
      },
			changeNav: function(item) {
				this.item = item
			},
			change_messageNumber: function(status) {
				if (status) {
					this.message_number = this.message_number - 1
				}
			}
		},
    mounted() {
      var that = this;
      console.log(111)
            axios.get('https://www.mools.net/lims/api/laravel/public/index.php/getMoolsNetLabList').then((response) => {
                      console.log(response.data.data[0].id)
                      that.getMoolsNetLabList = response.data.data;
                      //通过给定的ID来发送请求
                      axios.get("https://www.mools.net/lims/api/laravel/public/index.php/getMoolsNetExpList/"+response.data.data[0].id)
                        .then(function(response){
                          that.getMoolsNetExpList = response.data.data;
                          console.log(response);
                        })
                        .catch(function(err){
                          console.log(err);
                        });
                  }).catch((error) => {
                      console.log(error)
                  })

  //      get:function (date)
  // get('https://www.mools.net/lims/api/laravel/public/index.php/getMoolsNetLabList')
  //     .then(function (response) {
  //       console.log(response);
  //     })
  //     .catch(function (error) {
  //       console.log(error);
  //     });
    },
	}
</script>

<style scoped="scoped">
  .nexnextnavx ul li a{
    cursor: pointer;
  }
	.clear {
		clear: both;
	}

	body {
		background: #F6F7F9 !important;
	}

	.wp,
	#wp {
		width: 100%;
	}

	#nexpage {
		padding: 0;
	}

	.pg {
		margin-right: 0 !important;
	}

	.nexadsbanner {
		width: 100%;
		min-width: 1180px;
		height: 400px;
		background: url(http://www.mools.net/lims/web/OfficialWebsite/exam/bg_case.jpg) center no-repeat;
		position: relative;
	}

	.nexadsbanner em {
		display: block;
		width: 100%;
		min-width: 1180px;
		height: 400px;
		background: rgba(0, 0, 0, 0.5) url(http://www.mools.net/lims/web/OfficialWebsite/images/datu.png) 0 0 repeat;
		position: absolute;
		top: 0;
		left: 0;
	}

	.nexsubnavfg {
		width: 100%;
		min-width: 1180px;
		padding: 20px 0;
		background: #fff;
		box-shadow: 0 2px 3px #ededed;
	}

	.nexadsbanner h4 {
		font-size: 36px;
		max-width: 300px;
		margin: 0 auto;
		position: relative;
		top: 130px;
		text-align: center;
		letter-spacing: 4px;
		color: #fff;
		height: 70px;
		line-height: 70px;
		font-weight: 400;
		overflow: hidden;
	}

	.nex_tools {
		position: relative;
		z-index: 100;
		top: 140px;
	}

	.nex_tools a {
		display: block;
		width: 140px;
		height: 30px;
		line-height: 30px;
		text-align: center;
		background: #0095FF;
		border-radius: 24px;
		font-size: 14px;
		color: #fff;
		border-radius: 24px;
		margin: 0 auto;
	}

	.nex_tools a:hover {
		opacity: 0.9;
	}

	.nexprodesc {
		text-align: center;
		width: 800px;
		margin: 0 auto;
		height: 40px;
		line-height: 40px;
		overflow: hidden;
		position: relative;
		top: 125px;
		font-size: 16px;
		color: #fff;
	}

	.nexnextnavx {}

	.nexnextnavx ul {
		display: table;
		margin: 0 auto;
    padding: 0 60px;
	}

	.nexnextnavx ul li {
		float: left;
		margin: 0 15px;
		height: 25px;
		line-height: 25px;
	}

	.nexnextnavx ul li a {
		font-size: 16px;
		color: #666;
		font-weight: 400;
	}

	.nexnextnavx ul li a:hover {
		color: #0095FF;
	}

	.nexwp {
		width: 1180px;
		margin: 20px auto 0 auto;
	}

	.nex_portbox {
		margin-top: 20px;
	}

	.nex_portbox ul {
		width: 1205px;
	}

	.nex_portbox ul li {
		float: left;
		width:280px;
		margin: 0 20px 20px 0;
		background: #fff;
		-webkit-transition: all 0.3s linear;
		-moz-transition: all 0.3s linear;
		-o-transition: all 0.3s linear;
		-ms-transition: all 0.3s linear;
		transition: all 0.3s linear;
	}

	.nex_LG_box {}

	.nex_case_pic {
		width: 280px;
		height: 136px;
		overflow: hidden;
		position: relative;
	}

	.nex_case_pic img {
		width: 280px;
		height: 136px;
		transform: scale(1, 1);
		-webkit-transition: all 0.3s linear;
		-moz-transition: all 0.3s linear;
		-o-transition: all 0.3s linear;
		-ms-transition: all 0.3s linear;
		transition: all 0.3s linear;
	}

	.nex_case_pic:hover img {
		transform: scale(1.1, 1.1);
	}

	.nexoverlaystyle_one {
		position: absolute;
		background: rgba(0, 0, 0, 0.6);
		height: 100%;
		left: 0;
		top: 0;
		width: 100%;
		opacity: 0;
		text-align: center;
		-webkit-transform: perspective(400px) rotateX(-90deg);
		-moz-transform: perspective(400px) rotateX(-90deg);
		-ms-transform: perspective(400px) rotateX(-90deg);
		-o-transform: perspective(400px) rotateX(-90deg);
		transform: perspective(400px) rotateX(-90deg);
		-webkit-transform-origin: top;
		-moz-transform-origin: top;
		-ms-transform-origin: top;
		-o-transform-origin: top;
		transform-origin: top;
		-webkit-transition: all 0.5s;
		-moz-transition: all 0.5s;
		-o-transition: all 0.5s;
		transition: all 0.5s;
	}

	.nexinter_box {
		display: table;
		height: 100%;
		width: 100%;
	}

	.nexover_content {
		display: table-cell;
		text-align: center;
		vertical-align: middle;
	}

	.nexover_content a {
		opacity: 1;
		border: 1px solid #0095FF;
		display: inline-block;
		width: 40px;
		height: 40px;
		border-radius: 3px;
		font-size: 15px;
		line-height: 40px;
		transition: all 500ms ease;
		background: #0095FF;
	}

	.nexover_content a i {
		display: block;
		width: 40px;
		height: 40px;
		background: #0095FF url(http://www.mools.net/lims/web/OfficialWebsite/exam/link.png) center no-repeat;
		-webkit-transition: all 0.3s linear;
		-moz-transition: all 0.3s linear;
		-o-transition: all 0.3s linear;
		-ms-transition: all 0.3s linear;
		transition: all 0.3s linear;
	}

	.nexover_content a i:hover {
		transform: scale(1.2);
		-moz-transform: scale(1.2);
		-webkit-transform: scale(1.2);
		-o-transform: scale(1.2);
		-ms-transform: scale(1.2);
	}

	.nex_case_pic:hover .nexoverlaystyle_one {
		opacity: 1;
		-webkit-transform: perspective(400px) rotateX(0deg);
		-moz-transform: perspective(400px) rotateX(0deg);
		-ms-transform: perspective(400px) rotateX(0deg);
		-o-transform: perspective(400px) rotateX(0deg);
		transform: perspective(400px) rotateX(0deg);
	}


	.nex_LG_info {
		padding: 15px;
		position: relative;
	}

	.nex_LG_info h5 {
		height: 50px;
		line-height: 16px;
		overflow: hidden;
		margin: 10px 0;
	}

.nex_LG_info h5 a {
    font-size: 12px;
    color: #aaa;
    font-weight: 400;
}

	.nex_LG_info h5 a:hover {
		color: #0095FF;
	}

	.nex_LG_type {
	    font-size: 16px;
	    /* color: #aaa; */
	    margin-bottom: 10px;
	    height: 19px;
	    background: url(http://www.mools.net/lims/web/OfficialWebsite/exam/from.png) left center no-repeat;
	    padding-left: 23px;
          overflow: hidden;
	}

	.nex_LG_item {
		border-top: 1px solid #ededed;
		padding-top: 10px;

	}

	.nex_LG_item span {
		font-size: 12px;
		color: #bbb;
		margin-right: 10px;
		padding-left: 25px;
	}

	.nex_LG_item span.nex_statistics_view {
		background: url(http://www.mools.net/lims/web/OfficialWebsite/exam/viewx.png) left center no-repeat;
	}

	.nex_LG_item span.nex_statistics_comment {
		background: url(http://www.mools.net/lims/web/OfficialWebsite/exam/reply.png) left center no-repeat;
	}

	.nex_LG_item span.nex_statistics_date {
		padding-left: 22px;
		background: url(http://www.mools.net/lims/web/OfficialWebsite/exam/clock.png) left center no-repeat;
	}
</style>



// WEBPACK FOOTER //
// src/views/community/community.vue